import React, { useRef, useState } from 'react';
import { announcements, profileUrl, tweets } from '../data/tweets';
import './css/TwitterPostsSection.css';

const announcementLine = announcements.join('   •   ');

const TwitterPostsSection = () => {
  const scrollerRef = useRef(null);
  const [expanded, setExpanded] = useState({});
  const [active, setActive] = useState(0);
  const carousel = tweets.length > 3;

  const scrollToIndex = (index) => {
    const next = Math.max(0, Math.min(index, tweets.length - 1));
    const scroller = scrollerRef.current;
    const card = scroller?.children[next];
    if (card) {
      card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }
    setActive(next);
  };

  const onScroll = () => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const edge = scroller.getBoundingClientRect().right;
    let closest = 0;
    let best = Infinity;
    Array.from(scroller.children).forEach((card, index) => {
      const distance = Math.abs(card.getBoundingClientRect().right - edge);
      if (distance < best) {
        best = distance;
        closest = index;
      }
    });
    setActive(closest);
  };

  const onKeyDown = (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      scrollToIndex(active + 1);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      scrollToIndex(active - 1);
    }
  };

  return (
    <section className="twitter-posts" dir="rtl" aria-labelledby="twitter-posts-title">
      <div className="twitter-announce">
        <div className="twitter-announce-track">
          <span>{announcementLine}</span>
          <span aria-hidden="true">{announcementLine}</span>
        </div>
      </div>

      <div className="container twitter-posts-inner">
        <div className="twitter-posts-header">
          <h2 id="twitter-posts-title">آخر تغريداتنا</h2>
          <a href={profileUrl} target="_blank" rel="noopener noreferrer">
            تابعينا على X
          </a>
        </div>

        <div className={`twitter-posts-row ${carousel ? 'is-carousel' : ''}`}>
          {carousel && (
            <button
              type="button"
              className="twitter-arrow"
              aria-label="السابق"
              onClick={() => scrollToIndex(active - 1)}
              disabled={active === 0}
            >
              ›
            </button>
          )}

          <div
            className="twitter-posts-scroller"
            ref={scrollerRef}
            tabIndex={0}
            onScroll={onScroll}
            onKeyDown={onKeyDown}
            aria-label="تغريدات"
          >
            {tweets.map((tweet, index) => {
              const isOpen = !!expanded[tweet.id];
              const long = tweet.text.length > 140;
              return (
                <article className="twitter-card" key={tweet.id}>
                  <div
                    className="twitter-card-media"
                    style={{ aspectRatio: `${tweet.width} / ${tweet.height}` }}
                  >
                    <img
                      src={tweet.image}
                      alt={tweet.alt}
                      width={tweet.width}
                      height={tweet.height}
                      loading={index === 0 ? 'eager' : 'lazy'}
                      decoding="async"
                    />
                  </div>
                  <p className={`twitter-card-text ${isOpen ? 'is-open' : ''}`}>{tweet.text}</p>
                  {long && (
                    <button
                      type="button"
                      className="twitter-card-more"
                      onClick={() =>
                        setExpanded((current) => ({ ...current, [tweet.id]: !current[tweet.id] }))
                      }
                    >
                      {isOpen ? 'عرض أقل' : 'اقرأ المزيد'}
                    </button>
                  )}
                  {tweet.url && (
                    <a
                      className="twitter-card-link"
                      href={tweet.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      التغريدة الأصلية
                    </a>
                  )}
                </article>
              );
            })}
          </div>

          {carousel && (
            <button
              type="button"
              className="twitter-arrow"
              aria-label="التالي"
              onClick={() => scrollToIndex(active + 1)}
              disabled={active === tweets.length - 1}
            >
              ‹
            </button>
          )}
        </div>

        <div className="twitter-posts-dots">
          {tweets.map((tweet, index) => (
            <button
              key={tweet.id}
              type="button"
              className={index === active ? 'is-active' : ''}
              aria-label={`التغريدة ${index + 1}`}
              aria-current={index === active ? 'true' : undefined}
              onClick={() => scrollToIndex(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TwitterPostsSection;
